export const getDefaultRegion = (account, allRegions) => {
    const accountRegion = account?.region;
    const defaultRegion = allRegions?.find((region) => region.region === accountRegion);
    return defaultRegion || allRegions[0];
}

export const getDefaultAccount = (allCredentials) => {
    let selectedAccount = null;
    try {
        selectedAccount = JSON.parse(window.localStorage.getItem("iac-selected-account")) || {};
    } catch (error) {
        return allCredentials[0];
    }

    if (selectedAccount && selectedAccount.accountNumber) {
        return allCredentials.find((cred) => cred.accountNumber === selectedAccount.accountNumber);
    }

    return allCredentials[0];
};
